import { FunctionComponent } from "react";

import { DateTime } from "@bps/date-time";
import { FontIcon, Stack, Text } from "@bps/fluent-ui";

export interface InvalidRequestProps {
  description?: string;
  helpText?: string;
}

interface CompletedSurveyProps {
  isReadOnly?: boolean;
  documentDownloadCallBackUrl?: string;
  expiry?: DateTime;
  submittedDate?: DateTime;
  formId: string;
}

export const CompletedSurvey: FunctionComponent<CompletedSurveyProps> = () => {
  return (
    <Stack horizontalAlign="center" verticalAlign="center" verticalFill grow>
      <FontIcon
        iconName="Completed"
        className="bp-icon"
        styles={{
          root: {
            textAlign: "center",
            fontSize: 48,
            marginBottom: 16
          }
        }}
      />
      <Text variant="xLarge" styles={{ root: { textAlign: "center" } }}>
        Thank you for updating your details.
      </Text>
      <Text
        variant="medium"
        styles={{
          root: { textAlign: "center", paddingTop: 12, maxWidth: 348 }
        }}
      >
        Please contact the practice if you have any questions.
      </Text>
    </Stack>
  );
};
